<template>
  <button type='button' class='btn_excel' @click='onClickButton'>
    <span class='ico'></span>엑셀저장
    <div v-if='processing' class='hidden'>
      <slot />
    </div>
  </button>
</template>

<script>
const SHEET_NAME_LENGTH_LIMIT = 31;

export default {
  props: {
    filename: {
      type: String,
      default: 'happy_list',
    },
    table: {
      type: HTMLTableElement,
      default: null,
    },
    tablesContainer: {
      type: HTMLElement,
      default: null,
    },
  },
  data() {
    return {
      processing: false,
    };
  },
  methods: {
    onClickButton() {
      this.processing = true;
      if (this.tablesContainer) this.saveFromContainer();
      else this.$nextTick(this.saveFile);
      this.$emit('click');
    },
    async saveFile() {
      const excelModule = await import('xlsx'); // 파일이 커서 비동기 로드함.
      const XLSX = excelModule.default;
      const $table = this.table || this.$el.querySelector('table');
      if (!$table) {
        this.processing = false;
        return;
      }
      const wb = XLSX.utils.table_to_book($table, {
        sheet: $table
          .querySelector('caption')
          .innerText.trim()
          .replace(/[\\\/\?\*\[\]]/g, '_'),
        raw: true,
      });
      XLSX.writeFile(wb, `${this.filename}.xlsx`);
      this.$nextTick(() => (this.processing = false));
    },
    async saveFromContainer() {
      const excelModule = await import('xlsx');
      const XLSX = excelModule.default;
      const tables = this.tablesContainer.querySelectorAll('table');

      const wb = XLSX.utils.book_new();
      const sheets = _.map(tables, table => XLSX.utils.table_to_sheet(table));
      sheets.forEach((workSheet, index) => {
        const tableCaption = tables[index].querySelector('caption');
        const sheetName = tableCaption ? tableCaption.innerText.trim() : `sheet${index}`;
        XLSX.utils.book_append_sheet(
          wb,
          workSheet,
          sheetName.replace(/[\\\/\?\*\[\]]/g, '_').slice(0, SHEET_NAME_LENGTH_LIMIT),
        );
      });
      XLSX.writeFile(wb, `${this.filename}.xlsx`);
    },
  },
};
</script>

<style>
</style>
